export default __webpack_public_path__ + "static/media/nfc1.61b1948e.jpg";